/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

const DisplaySettingsWrapper = (props) => {
    
    const { t } = useTranslation();
    const children = props?.children;
    const { field } = useCurrentDynamicField();
    const fieldSettings = field?.settings;
    const hide = fieldSettings?.hide;

    return (
        <Fragment>
            {!hide &&
                <Fragment>
                    {/*For Settings, we will update the field.settings, not field.schema.settings */}
                    <div className='display-settings'>
                        <div className='header'>{t("commons.displaySettings")}</div>
                        {children}
                    </div>
                </Fragment>
            }
            {hide &&
                <Fragment>
                    <div className='display-settings'>
                        <div className='header'>{t("commons.displaySettings")}</div>
                        <div style={{
                            width: "100%",
                            height: "72px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#7A7A7A",
                        }}
                        >
                            No display settings
                        </div>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
};
export { DisplaySettingsWrapper };
